module.exports = ["はると","まこと","たつや","はるき","りく","そうた","みなと","あきら","ひなた","こうき","ゆうせい","かなた","そうま","かいと","はやと","はる","あさひ","ゆうま","てつや","ゆうき","そら","ふゆと","いつき","こうた","ひろと","あやと","ゆうすけ","あきひろ","たいせい","れん","あおと","えいた","ゆう","けん","こうたろう","たくみ","たけし","たまき","まもる","けい","けいた","ゆうた","あらた","さとし","やまと","たろう","たかし","いちろう","けんいち","ひかる"]


//////////////////
// WEBPACK FOOTER
// ./src/data/collections/names-male.json
// module id = 99
// module chunks = 0